import React from 'react';
import styled, { css } from 'styled-components';
import { Button, ButtonColor, SButton } from '../../../ui/button/Button';
import InputGroup from '../../../ui/inputGroup/InputGroup';
import Popup from '../../../ui/popup/Popup';
import SsnInput from '../../../ui/ssnInput/SsnInput';
import CommonSection from '../commonSection/CommonSection';
import SectionTitle from '../sectionTitle/SectionTitle';
import CardApplyButton from '../cardApplyButton/CardApplyButton';

// ############################ Styles ###########################
// tslint:disable:variable-name

const SFullSsnRequired = styled.section``;

const SFullSsnRequiredInner = styled(Popup)(
  ({ theme }) => `
  @media only screen and ${theme.device.laptopS} {
    width: 800px;
  }
`
);

const STitle = styled.h1(
  ({ theme }) => `
  font-weight: ${theme.font.weight.normal};
  color: ${theme.colors.dark};
  font-size: ${theme.font.size.medium3};
  @media only screen and ${theme.device.laptopS} {
    font-size: ${theme.font.size.mediumLarge};
  }
`
);

const SSectionTitle = styled(SectionTitle)(
  ({ theme }) => `
  @media only screen and ${theme.device.laptopS} {
    font-size: ${theme.font.size.medium};
  }
`
);

const SCommonSectionWithMoreSpacing = styled(CommonSection)(
  ({ theme }) => `
  margin-bottom: ${theme.spacing.larger}px;
`
);

const SCommonSectionActions = styled(CommonSection)(
  ({ theme }) => `
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  ${SButton}:not(:first-child) {
    margin-left: ${theme.spacing.large}px;
  }
`
);

// tslint:enable:variable-name
// ############################ End Styles ###########################

// tslint:disable-next-line:no-empty-interface
interface IFullSsnRequiredProps {
  ssn?: string;
  onShow?: () => void;
  submit: (ssn: string) => void;
}

const SLabel = styled.p(({ theme }) => ({
  color: theme.colors.primary,
}));
// tslint:disable-next-line:variable-name
const FullSsnRequired: React.FC<IFullSsnRequiredProps> = (props) => {
  const [ssn, setSsn] = React.useState<string>('');

  React.useLayoutEffect(() => {
    if (props.onShow) {
      props.onShow();
    }
  }, []);

  React.useEffect(() => {
    setSsn(props.ssn || '');
  }, [props.ssn]);

  const handleOnChange = React.useCallback(
    (value: string) => {
      setSsn(value);
    },
    [setSsn]
  );

  const handleSubmit = React.useCallback(() => {
    props.submit(ssn);
  }, [ssn]);

  const isValid = React.useCallback(() => ssn.length === 9, [ssn]);

  return (
    <SFullSsnRequiredInner data-at="fullSsnRequiredContainer">
      <SFullSsnRequired>
        <CommonSection>
          <STitle data-at="fullSsnRequiredTitle">Full SSN Required</STitle>
        </CommonSection>
        <CommonSection>
          <SSectionTitle data-at="fullSsnRequiredSubtitle">Unfortunately, we were unable to verify your identity. Let&apos;s try again using your full SSN.</SSectionTitle>
        </CommonSection>
        <SCommonSectionWithMoreSpacing>
          <InputGroup dataAt="ssnGroup">
            <SsnInput dataAt="ssn" name="ssn" label={<SLabel>SSN</SLabel>} value={ssn} onChange={handleOnChange} />
          </InputGroup>
        </SCommonSectionWithMoreSpacing>
        <SCommonSectionActions>
          <CardApplyButton dataAt="submitSsnButton" color={ButtonColor.primaryLightBlue} onClick={handleSubmit} disabled={!isValid()}>
            Submit
          </CardApplyButton>
        </SCommonSectionActions>
      </SFullSsnRequired>
    </SFullSsnRequiredInner>
  );
};

export default FullSsnRequired;
